import { useEffect } from 'react';

export function usePageTitle(title?: string) {
  useEffect(() => {
    const baseTitle = 'Checkademic';
    document.title = title ? `${baseTitle} - ${title}` : baseTitle;

    return () => {
      document.title = baseTitle;
    };
  }, [title]);
}
